/*
=========================================================
* FMP Soluções — Academia Ciber / E-Learning
* Rota: /pages/academia-ciber/e-learning
=========================================================
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Navbar / Footer
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import FMPFooter from "examples/Footers/FMPFooter";

// Sections
import CourseList from "pages/AcademiaCiber/Treinamento/sections/CourseList";
import WhyELearning from "pages/AcademiaCiber/Treinamento/sections/WhyELearning";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Image
import bgImage from "assets/images/treinamento.jpg";

function Treinamento() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/pages/ajuda/contate-nos",
          label: "Contate-nos",
          color: "info",
        }}
        sticky
      />

      {/* Hero */}
      <MKBox
        minHeight="50vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} md={8} justifyContent="center" mx="auto" textAlign="center">
            <MKTypography variant="h1" color="white" mb={1}>
              E-Learning
            </MKTypography>
            <MKTypography variant="h5" color="white" opacity={0.8} mb={3}>
              Cursos garantidos pelo NCSC do Reino Unido — flexíveis, escaláveis e adaptados ao
              seu setor. Aprenda no seu ritmo com certificação internacional na conclusão.
            </MKTypography>
            <MKButton
              variant="gradient"
              color="info"
              size="large"
              component="a"
              href="/pages/ajuda/contate-nos"
            >
              Solicitar informações
            </MKButton>
          </Grid>
        </Container>
      </MKBox>

      {/* Conteúdo */}
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <CourseList />
        <WhyELearning/>
      </Card>

      <MKBox pt={6} px={1} mt={6}>
        <FMPFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Treinamento;
